module.exports = __webpack_public_path__ + "img/clock-red.b137a1e9.svg";